// 设备管理
export default {
    devmanage: "设备管理",
    uavdevdetails: '设备详情(无人机)',
    life: '寿命统计',
    ptzdevdetails: '设备详情(云台)',
    battydevdetails: '设备详情(智能电池)',
    rtkdevdetails: '设备详情(RTK)',
    sn: 'SN',
    devname: '设备名称',
    pinputname: '请输入设备名称',
    pinputsn: '请输入设备SN码',
    search: '搜 索',
    adddev: '添加设备',
    devtype: '设备类型',
    devstate: '设备状态',
    networkstate: '网络状态',
    screen: '筛 选',
    devnum: '设备数量',
    inputtime: '录入时间',
    vision: '版本号',
    dtime: '出厂时间',
    Atime: '激活时间',
    SS: '共享状态',
    QXA: '千寻账号',
    operation: '操作',
    details: '详情',
    edit: '编辑',
    share: '快速共享',
    QX: '千寻设置',
    delete: '删除',
    editdev: '编辑设备',
    devsn: '设备',
    deletes: '批量删除',
    remarks: '备注',
    uav: '无人机',
    znBattery: '智能电池',
    ptz: '云台',
    normal: '正常',
    reparied: '待维修',
    under: '维修中',
    scrap: '报废',
    onlin: '在线',
    offline: "离线",
    psearch: '请先搜索',
    deldevmes: '删除之后您将无法使用该设备,是否继续？',
    delchedevmes: '删除之后您将无法使用选中的设备,是否继续？',
    SU: '共享用户',
    mobile: '手机',
    flymodel: '飞机型号',
    Battery: '电池',
    Batterymodel: '电池型号',
    defects: '保修期',
    BMSv: 'BMS版本',
    totaltime: '使用总时间',
    cffreq: '充放次数',
    reslife: '剩余寿命',
    usefullife: '已用寿命',
    batterylife: "电池寿命统计",
    ptzmodel: '云台型号',
    day: '天',
    firmv: '固件版本',
    rtk: '基站',
    model: '型号',
    long: '经度',
    lat: '纬度',
    basertk: '基站海拔',
    coverage: '覆盖范围',
    satenum: '卫星数量',
    positionlong: '定位精度',
    positiontype: '定位状态',
    NS: '联网状态',
    flysn: '飞机',
    flynum: '飞行次数',
    EAV: '电调版本',
    flytotaltime: '飞行总时长',
    lifestatistic: '寿命统计',
    Flightv: '飞控版本',
    gatewayv: '网关版本',
    Fligh: '飞控',
    gateway: '网关',
    radar: '对地雷达',
    receiver: '接收机',
    parachute: '降落伞',
    elemach: '电机',
    elereg: '电调',
    motor: '马达',
    totalflightmil: '飞行总里程',
    uavlifestatistic: '无人机寿命统计',
    parachuteLife: '降落伞寿命',
    armNumber: '{0}号机臂',
    AS: '已共享',
    WS: '被共享',
    month: '月',
    tip_DP: '设备名称重复,请重新输入',
}